<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="equipment">Equipment</label>
                    <input type="text" class="form-control" [(ngModel)]="target.equipment" name="equipment" id="equipment" />
                </div>
            </div>
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="vendorId">Rental Company</label>
                    <wj-combo-box
                        [(ngModel)]="target.vendorId"
                        name="vendorId"
                        id="vendorId"
                        [itemsSource]="vendorMap"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="false"
                    ></wj-combo-box>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12 col-12">
                <div class="form-group">
                    <label for="jobId">Job</label>
                    <wj-combo-box
                        [(ngModel)]="target.jobId"
                        name="jobId"
                        id="jobId"
                        [itemsSource]="jobMap"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="false"
                    ></wj-combo-box>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="rentedById">Rented By</label>
                    <wj-combo-box
                        [(ngModel)]="target.rentedById"
                        name="rentedById"
                        id="rentedById"
                        [itemsSource]="userList"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="false"
                    ></wj-combo-box>
                </div>
            </div>
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="pickedUpById">Picked Up By</label>
                    <wj-combo-box
                        [(ngModel)]="target.pickedUpById"
                        name="pickedUpById"
                        id="pickedUpById"
                        [itemsSource]="userList"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                        [isRequired]="false"
                    ></wj-combo-box>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-4 col-12">
                <div class="form-group">
                    <label for="billingCycle">Rental Length</label>
                    <wj-combo-box
                        [(ngModel)]="target.billingCycle"
                        name="billingCycle"
                        id="billingCycle"
                        [itemsSource]="billingCycleMap"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                </div>
            </div>

            <div class="col-sm-4 col-12">
                <div class="form-group">
                    <label for="pickedUpDate">Picked Up Date</label>
                    <wj-input-date
                        [(ngModel)]="target.pickedUpDate"
                        name="pickedUpDate"
                        id="pickedUpDate"
                        [isRequired]="false"
                        (ngModelChange)="calculateReturnDate()"
                    ></wj-input-date>
                </div>
            </div>

            <div class="col-sm-4 col-12">
                <div class="form-group">
                    <label for="scheduledReturnDate">Scheduled Return Date</label>
                    <wj-input-date
                        [(ngModel)]="target.scheduledReturnDate"
                        name="scheduledReturnDate"
                        id="scheduledReturnDate"
                        [isRequired]="false"
                    ></wj-input-date>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="vendorMaintains">Maintained By</label>
                    <wj-combo-box
                        [(ngModel)]="target.vendorMaintains"
                        name="vendorMaintains"
                        id="vendorMaintains"
                        [itemsSource]="maintMap"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                </div>
            </div>
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="fuelType">Fuel Type</label>
                    <wj-combo-box
                        [(ngModel)]="target.fuelType"
                        name="fuelType"
                        id="fuelType"
                        [itemsSource]="fuelTypeMap"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 col-12">
                <div class="form-group">
                    <label for="returnedDate">Returned Date</label>
                    <wj-input-date
                        [(ngModel)]="target.returnedDate"
                        name="returnedDate"
                        id="returnedDate"
                        [isRequired]="false"
                    ></wj-input-date>
                </div>
            </div>
            <div class="col-sm-3 col-12">
                <div class="form-group">
                    <label for="rate">Rate ($)</label>
                    <input type="number" class="form-control" [(ngModel)]="target.rate" name="rate" id="rate" />
                </div>
            </div>
            <div class="col-sm-3 col-12">
                <div class="form-group">
                    <label for="rateUnit">Rate Unit</label>
                    <wj-combo-box
                        [(ngModel)]="target.rateUnit"
                        name="rateUnit"
                        id="rateUnit"
                        [itemsSource]="rateUnitMap"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-3 col-12">
                <div class="form-group">
                    <label for="hoursStart">Hours Start</label>
                    <input type="number" class="form-control" [(ngModel)]="target.hoursStart" name="hoursStart" id="hoursStart" />
                </div>
            </div>
            <div class="col-sm-3 col-12">
                <div class="form-group">
                    <label for="hoursEnd">Hours End</label>
                    <input type="number" class="form-control" [(ngModel)]="target.hoursEnd" name="hoursEnd" id="hoursEnd" />
                </div>
            </div>
            <div class="col-sm-3 col-12">
                <div class="form-group">
                    <label for="serialNum">Serial Number</label>
                    <input type="text" class="form-control" [(ngModel)]="target.serialNum" name="serialNum" id="serialNum" />
                </div>
            </div>
            <div class="col-sm-3 col-12">
                <div class="form-group">
                    <label for="isRpo">Is RPO</label>
                    <wj-combo-box
                        [(ngModel)]="target.isRpo"
                        name="isRpo"
                        id="isRpo"
                        [itemsSource]="boolMap"
                        [displayMemberPath]="'display'"
                        [selectedValuePath]="'value'"
                    ></wj-combo-box>
                </div>
            </div>
        </div>
        @if (target.imageUrls && target.imageUrls.length > 0) {
            <div class="row">
                <label for="images-display">Images</label>
                @for (url of target.imageUrls; track url) {
                    <div class="col-sm-6 col-6" style="margin-bottom: 10px">
                        <img style="width: 100%" [src]="'./Resources/Images/Rental/' + url + '?w=300'" />
                    </div>
                }
            </div>
        }
        @if (images && images.length > 0) {
            <div class="row">
                <label for="images-upload">Images To Upload</label>
                @for (image of images; track image) {
                    <div class="col-sm-6 col-6" style="margin-bottom: 10px">
                        <div class="close-x" (click)="removeImage(image)">
                            <fa-icon [icon]="faX"></fa-icon>
                        </div>
                        <img style="width: 100%" [src]="image.url" />
                    </div>
                }
            </div>
        }
        @if (progress > 0 && progress < 100) {
            <div class="row">
                <div class="col-12">
                    <div class="progress">
                        <div
                            class="progress-bar"
                            role="progressbar"
                            [ngStyle]="{ 'width.%': progress }"
                            aria-valuenow="25"
                            aria-valuemin="0"
                            aria-valuemax="100"
                        >
                            {{ progress }}%
                        </div>
                    </div>
                </div>
            </div>
        }
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" style="margin-right: auto" (click)="fileInput.click()">Upload Image(s)</button>
        <input style="display: none" type="file" (change)="onFileChanged($event)" accept="image/*" #fileInput multiple />
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
